import { Component, Input, ViewEncapsulation } from '@angular/core';

@Component({
  selector: 'crowdctrl-form-layout',
  standalone: true,
  templateUrl: './form-layout.component.html',
  styleUrl: './form-layout.component.css',
  encapsulation: ViewEncapsulation.None,
})
export class FormLayoutComponent {
  @Input() heading = '';
  @Input() description = '';
  @Input() errorMessage = '';
  @Input() headingId: string | null = null;
  @Input() standalone = false;

  /**
   * Extra horizontal inset on this layout host. Default false so `crowdctrl-page` /
   * `crowdctrl-tab-page` / `crowdctrl-unauthenticated-page` can own one consistent `ion-content`
   * inset for all content (lists, prose, forms). Set true only when the form sits on an unpadded
   * scroll surface (e.g. `contentClass="ion-padding-bottom"` list-first pages).
   */
  @Input() padHorizontal = false;

  /**
   * Extra vertical inset on this layout host. Same contract as {@link FormLayoutComponent#padHorizontal}.
   */
  @Input() padVertical = false;
}
